import { CorpTypeList1 } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";

const steps = ["通知待ち", "完了"];

/* フェイクテーブルリスト */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "登録者様のご確認",
    keyword: "businessOwnerClass",
    type: "radio",
    radioPropsList: TkGetCodeList(CorpTypeList1),
    requiredIcon: true,

    disabled: true,
    guideMessage:
      "※社会福祉法人以外の場合は契約ができません。なお、学校法人の場合は画面上部の「問い合せ」ボタンから機構へお問い合わせください",
  },
  {
    title: "経営している主な施設の種類",
    keyword: "mainFacilityKinds",
    type: "text",
    requiredIcon: true,

    disabled: true,
    isSCRC030001: false,
  },
  {
    title: "法人名(ｶﾅ)",
    keyword: "corpNameKana",
    requiredIcon: true,

    disabled: true,
    convertToHalfwidth: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "法人名",
    keyword: "corpName",
    requiredIcon: true,

    disabled: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "代表者職名",
    keyword: "directorTitle",
    requiredIcon: true,

    disabled: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "代表者氏名",
    keyword: "directorName",
    type: "name",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: "法人所在地郵便番号",
    keyword: "zipcode",
    type: "addressSearch",
    requiredIcon: true,

    disabled: true,
    inputProps: { maxLength: 7 },
  },
  {
    title: "法人所在地",
    keyword: "address",
    type: "locationGroup",
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
    requiredIcon: true,

    disabled: true,
  },
  {
    title: "法人番号",
    keyword: "corpNo",

    disabled: true,
    inputProps: { maxLength: 13 },
  },
  {
    title: "代表電話番号",
    keyword: "tel",
    type: "phoneNum",
    requiredIcon: true,

    disabled: true,
    inputProps: { maxLength: 19 },
  },
  {
    title: "代表FAX番号",
    keyword: "fax",
    type: "phoneNum",

    disabled: true,
    inputProps: { maxLength: 19 },
  },
  {
    title: "担当者 所属部署名",
    keyword: "managerDeptName",
    requiredIcon: true,

    disabled: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "担当者 役職",
    keyword: "managerPosition",
    requiredIcon: true,

    disabled: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "担当者 氏名",
    keyword: "managerName",
    requiredIcon: true,
    disabled: true,
    type: "name",
  },
  {
    title: "担当者 電話番号",
    keyword: "managerTel",
    type: "phoneNum",
    requiredIcon: true,

    disabled: true,
    inputProps: { maxLength: 19 },
  },
  {
    title: "連絡先メールアドレス",
    keyword: "managerEmail",
    requiredIcon: true,

    disabled: true,
    inputProps: { maxLength: 255 },
  },
  {
    title: "連絡先メールアドレス(確認用)",
    keyword: "emailConfirm",
    requiredIcon: true,
    disabled: true,
    inputProps: { maxLength: 255 },
  },
];

export { steps, fakeTableList };
